import { Inter, Shantell_Sans } from 'next/font/google'
import localFont from 'next/font/local'

import css from './fonts.module.css'

export const inter = Inter({
    weight: 'variable',
    subsets: ['latin'],
    display: 'swap',
    variable: '--next-font-family-body',
    fallback: ['Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'],
    style: ['normal', 'italic'],
})

export const shantell = Shantell_Sans({
    weight: 'variable',
    subsets: ['latin'],
    display: 'swap',
    variable: '--handwritten-base-font-family',
    fallback: ['Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'],
    adjustFontFallback: false,
})

export const graphik = localFont({
    src: [
        {
            path: '../public/static/fonts/Graphik-Regular-Web.woff',
            weight: '400',
            style: 'normal',
        },
        {
            path: '../public/static/fonts/Graphik-Medium-Web.woff',
            weight: '500',
            style: 'normal',
        },
        {
            path: '../public/static/fonts/Graphik-Semibold-Web.woff',
            weight: '600',
            style: 'normal',
        },
    ],
    display: 'swap',
    variable: '--next-font-family-sans',
    fallback: ['Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'],
    preload: false,
})

export const caecilia = localFont({
    src: [
        {
            path: '../public/static/fonts/Caecilia-Regular-Web.woff',
            weight: '400',
            style: 'normal',
        },
        {
            path: '../public/static/fonts/Caecilia-RegularItalic-Web.woff',
            weight: '400',
            style: 'italic',
        },
        {
            path: '../public/static/fonts/Caecilia-Bold-Web.woff',
            weight: '700',
            style: 'normal',
        },
        {
            path: '../public/static/fonts/CaeciliaLTStd-HeavyItalic.otf',
            weight: '700',
            style: 'italic',
        },
    ],
    display: 'swap',
    variable: '--next-font-family-serif',
    fallback: ['serif'],
    preload: false,
})

export const espa = localFont({
    src: '../public/static/fonts/Espa-Extended.woff',
    weight: '400',
    style: 'normal',
    display: 'swap',
    variable: '--next-font-family-handwritten',
    fallback: ['Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'],
    preload: false,
})

export const fonts = [
    inter.className, // default text style
    inter.variable,
    shantell.variable,
    graphik.variable,
    caecilia.variable,
    espa.variable,
    css.injectFonts,
]
